import i18n from '../../../../locales/index'
import HeaderBar from './header-bar'
export default HeaderBar
